<template>
	<h2 class="font-open-sans text-2xl font-bold tracking-tight text-gray-900">
		<slot />
	</h2>
</template>
